import React, { useState, useCallback } from 'react';

import clsx from 'clsx';

import { Link, Icon, Text } from '@atoms';

import { BaseNavLink, BasicNavLink, NestedNavLink } from '../nav.links';

import classes from './nav-link.module.scss';

type NavLinkType = BaseNavLink & Partial<BasicNavLink> & Partial<NestedNavLink>;

type NavLinkProps = {
  currentPath: string;
  isScrolled: boolean;
} & NavLinkType;

export const NavLink = ({
  currentPath,
  isScrolled,
  message,
  link,
  activeMatch,
  subLinks,
  external = false,
}: NavLinkProps) => {
  const [open, setOpen] = useState(false);
  const active = activeMatch && currentPath.match(activeMatch);
  const className = clsx(
    classes.navLink,
    active && classes.active,
    open && classes.open,
  );

  const toggleOpen = useCallback(() => setOpen((isOpen) => !isOpen), [false]);

  const inner = [
    <Text
      element="span"
      type="h6"
      color="big_stone"
      message={message}
      key="title"
    />,
  ];

  if (link) {
    return (
      <Link className={className} {...link} external={external}>
        {inner}
      </Link>
    );
  }

  if (subLinks) {
    return (
      <div onClick={toggleOpen} className={className}>
        {/* INNER MESSAGE */}
        {inner}
        {/* ICON */}
        <Icon icon="chevron-down" />
        {/* SUB MENU */}
        <div className={clsx(classes.subMenu, isScrolled && classes.scrolled)}>
          {subLinks.map((navLink) => (
            <Link
              key={navLink.message.id}
              {...navLink.link}
              className={classes.subMenuLink}
            >
              <Text
                element="span"
                type="h6"
                color="big_stone"
                message={navLink.message}
              />
            </Link>
          ))}
        </div>
      </div>
    );
  }

  return null;
};
